import Vue from 'vue'
import Vuex from 'vuex'
import './../plugins/axios'
import {
  setObj
} from "../plugins/util"
import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {},
    routerRecord: [],
    template: {
      default: {},
      edit: {}
    },
    product: {
      list: [],
      pagination: {}
    },
    orders: {
      list: [],
      pagination: {}
    },
    buyerOrders: {
      list: [],
      pagination: {}
    },
    cart: [],
    address: {},
    defaultAddressRadio: '',
    productInfo: {
      'ProductName': {
        name: 'Product Name (产品名称、标题)',
        content: [{
            title: '1、标题构成：关键词+产品标签',
            content: []
          },
          {
            title: '2、标题作用：被客户搜索的关键词、产品标签涵盖在标题中；提升商品的“曝光率”。',
            content: []
          },
          {
            title: '3、关键词、产品标签在标题中的应用',
            content: [
              '①  最容易被客户使用搜索的“关键词、产品标签”是最好的词；可以是一个词，一句，或一个字或一组数字；',
              '②  如果商品有“品牌”，请把品牌词放在最前面；',
              '③  标题中请不要使用“非法关键词”。如：杨幂同款、黑鬼、阿三、矮子、胖哥、胖妹等词语；',
              '④  标题中最好不要使用3个以上的关键词堆砌；'
            ]
          },
          {
            title: '4、标题统一规则',
            content: [
              '①  请不要在标题中使用“！”、“？”、“#”和中文状态下的标点符号；',
              '②  标题中每个独立单词要首字母要“大写”，并用“空格”分隔，介词如“off”、“and”、“in”、“one”等除外；',
              '③  标题总长度最好不要超过200个字符；（每个汉字2个字符）',
              '④  标题中不能含有任何促销信息和卖家信息，如：“免运费”、“优惠30%”、“折扣”、“卖家地址”等；'
            ]
          },
          {
            title: '5、其他注意事项',
            content: [
              '①  如有数字描述请使用阿拉伯数字，不要使用 文字例如：要写2 不要写Two。',
              '②  商品名称不能有自己的SKU 号码或者其他编码。',
              '③  如包含批量销售，请在商品名称后面添加（pack of X）。'
            ]
          },
        ],
        example: [
          'Aakerrr® Rugged Dual Layer Case for iPhone 6 with Kickstand (Snow White, Pack of 3)'
        ]
      },
      'Tags': {
        name: 'Tags (产品标签)',
        content: [{
            title: '1、标签的定义',
            content: ['产品标签通常是指用于识别产品本身的形状、质量、数量、特征、特性和使用方法等所做的各种表示的统称；产品标签可以用文字、符号、数字、图案以及其他说明物等表示。']
          },
          {
            title: '2、产品标签的构成',
            content: [
              '包括：类目词、属性词、材质词、修饰词、场景词等。在电子商务经营或引擎搜索中，很多情景下产品标签可以当做“关键词”来使用。'
            ]
          }
        ],
        example: [
          '一款女士单肩斜跨手提包，设想一下有哪些标签可以完整而精确地描述。',
          '形状：蝙蝠包',
          '颜色特性：撞色',
          '扣型：锁扣',
          '包扣颜色：金属扣',
          '特征：翻盖',
          '包带：单肩挂扣带、手动调节带',
          '有无提手：单手柄',
          '闭合方式：开口式',
          '内置：开口袋',
          '工艺：压花',
          '材料：头层牛皮+PU'
        ]
      },
      'Keywords': {
        name: 'Keywords（关键词）',
        content: [{
            title: '1、关键词定义',
            content: [
              '是指搜索引擎用户，输入搜索框中想要通过搜索引擎查找相关信息的用语。它可以是一个字，也可以是一个词、一句话、一个英字母、英文单词、一个数字、一个符号等任何可以在搜索框中输入的信息。'
            ]
          },
          {
            title: '2、关键词分类',
            content: [
              '关键词使用分类上分为：关键字、核心关键词、长尾关键词、导航型关键词等。'
            ]
          },
          {
            title: '3、关键词组成',
            content: [
              '商标（品牌）：如：Nike、Adidas、鸿星尔克、三只松鼠、Apple 7等；',
              '风格：欧美、韩版、休闲、商务、波西米亚风、cosplay、朋克等；',
              '商品本身属性：手机、衬衫、夹克、连衣裙、耳环、鞋等；',
              '性别指向：男士、女士、女孩、儿童、婴儿等；',
              '时间指向：春季、夏季、秋季、冬季、四季、2020、2019、圣诞节、情人节等；',
              '场景指向：户外、运动、游泳、室内、草坪、沙滩等；',
              '功能：抗菌、防水、防嗮、耐磨、柔软、弹力、自动断电等；',
              '工艺：印花、蕾丝、拼接、撞色、冲压、镶嵌、抛光、手工、破洞、磨砂、3D打印等；',
              '新技术：智能、大数据、发光、自热等；'
            ]
          }
        ]
      },
      "SuitFestival": {
        name: 'Suit Festival(销售最佳的节日)',
        content: [{
          title: '产品最适合销售的节日',
          content: []
        }]
      },
      "SuitCountry": {
        name: 'Suit Country(销售最佳的国家)',
        content: [{
          title: '产品最适合销售的国家',
          content: []
        }]
      },
      'Brand': {
        name: 'Brand（品牌）',
        content: [{
            title: '1、品牌是指商品的商标名称的统称；',
            content: []
          },
          {
            title: '2、品牌是最好的关键词；',
            content: []
          },
          {
            title: '3、品牌单词拼写要尊重注册商品的拼写方法，如：NIKE、iPhone 7；',
            content: []
          },
          {
            title: '4、如果商品没有品牌，建议虚拟一个商品品牌，更容易吸引消费者；',
            content: []
          },
          {
            title: '5、“品牌”关键词建议放在标题的最前面；',
            content: []
          },
        ]
      },
      'SKU': {
        name: 'SKU（商品变体）',
        content: [{
            title: '1、Stock Keeping Unit (库存量单位)，是产品统一编号的简称，每种产品均对应有唯一的SKU号；',
            content: []
          },
          {
            title: '2、SKU是指一款商品，每款都有出现一个SKU，便于电商品牌识别商品；',
            content: []
          },
          {
            title: '3、一款商品多色，则是有多个SKU，例:一件衣服，有红色、白色、蓝色，则SKU编码也不相同，如相同则会出现混淆，发错货；',
            content: []
          },
          {
            title: '4、一个SKU是靠一串唯一编码来标识的，比如1234A，1234B。一般来说一个平台下不会存在两个相同的SKU，或这一个店铺下不会存在两个相同的SKU。',
            content: []
          },
          {
            title: '5、SKU编码位数通常由10位数的阿拉伯数字或字母构成，可以根据自己的识别习惯编写，如：2020040601,2020040602等。',
            content: []
          },
        ]
      },
      'Description': {
        name: 'Description（描述）',
        content: [{
            title: '1、描述中最好使用关键词作为引导词来写；',
            content: []
          },
          {
            title: '2、描述中要突出产品特点、优势、使用场景；',
            content: []
          },
          {
            title: '3、描述中要有使用方法、注意事项、尺码对照表；',
            content: []
          },
          {
            title: '4、文笔流畅，语法，结构，措辞尽量贴近消费者国家人群的语言习惯；',
            content: []
          },
          {
            title: '5、描述中不能含有促销信息和卖家信息；',
            content: []
          },
          {
            title: '6、由于描述文字较多，请习惯使用换行分段处理信息；',
            content: []
          },
        ]
      },
      'Price': {
        name: 'Price (价格设置)',
        content: [{
            title: '1、请根据当时汇率换算成美元标注刊登价格；',
            content: []
          },
          {
            title: '2、定价公式方法',
            content: [
              '①成本定价法：货物成本*系数=零售价；',
              '②比较定价法：搜索同款产品所有卖家，取其平均价格作为零售价，可在均价“+、-”值3%进行定价；',
              '③精准定价法：货物成本+国际物流成本+平台佣金+退换货率（预估一个比例）+利润（根据不同品类利润空间和市场竞争度，合理预估）=零售价。'
            ]
          }
        ]
      },
      'Logistic': {
        name: 'Logistic（物流）',
        content: [{
          title: '物流费用',
          content: []
        }]
      },
      'TimeLiness': {
        name: 'Timeliness（时效）',
        content: [{
            title: '1、根据填写的物流方式，填写物流公司给出的时效，如：7个工作日等；',
            content: []
          },
          {
            title: '2、跨境电商中物流时效是指送达时间，也称“配送周期”',
            content: []
          },
          {
            title: '3、请不要把物流时效填写超过14天，如果在海外仓有备货，可以实现当地配送，时效可以填写2-3天；',
            content: []
          }
        ]
      },
      'Profits': {
        name: 'Profits（利润）',
        content: [{
          title: '1、利润值可以填写定价的15%-20%左右即可；',
          content: []
        }]
      },
      'MSRP': {
        name: 'MSRP（厂家建议零售价）',
        content: [{
          title: '1、厂家建议零售价格可以填写高于你定的零售价格，显示你当前的打折力度。如厂家建议零售价：50＄，定价为：32＄；',
          content: []
        }]
      },
      'Inventory': {
        name: 'Inventory (库存)',
        content: [{
          title: '1、库存不能为“负数”或“0”，根据消费心理学反映，库存数量30-100最容易被消费者接受。',
          content: []
        }]
      },
      'UPC': {
        name: 'UPC',
        content: [{
            title: '1、统一商品编码（Universal Product Code），UPC条码也是用于商品的条码，主要用于美国和加拿大地区，UPC条码是由美国统一代码委员会制定的一种条码。我国有些出口到北美地区为了适应北美地区的需要，也需要申请UPC条码，UPC条码也有标准版和缩短版两种，标准版由12位数字构成，缩短版由8位数字构成；',
            content: []
          },
          {
            title: '2、标准版的UPC12的编码结构为:系统码(1位)+厂商码(5位)+商品码(5位)+校检码(1位)。',
            content: []
          },
          {
            title: '3、UPC码是需要付费购买，每个SKU对应有一个UPC码。',
            content: []
          },
          {
            title: '4、欧美电商平台刊登产品时，要求使用UPC码。',
            content: []
          }
        ]
      },
      'DeclareName': {
        name: 'Declare Name（申报名称）',
        content: [{
          title: '填写物品品类名称',
          content: []
        }]
      },
      'PackageLength': {
        name: 'Package Length（行李长度）',
        content: [{
          title: '填写物品的长度',
          content: []
        }]
      },
      'PackageHeight': {
        name: 'Package Height（包装高度）',
        content: [{
          title: '填写包装物的高度',
          content: []
        }]
      },
      'Weight': {
        name: 'Weight（重量）',
        content: [{
          title: '填写物品重量，按“克”计算（不含包装重量）',
          content: []
        }]
      },
      'CountryOfOrigin': {
        name: 'Coyntry of Origin（生产国）',
        content: [{
          title: '原产地国家',
          content: []
        }]
      },
      'DeclareLocalName': {
        name: 'Declare Local Name（申报地名称）',
        content: [{
          title: '以原产国的当地语言申报名称',
          content: []
        }]
      },
      'PackageWidth': {
        name: 'Package Width（行李宽度）',
        content: [{
          title: '填写物品宽度',
          content: []
        }]
      },
      'CustomHSCode': {
        name: 'Custom HS Code（自定义HS海关提货单编码）',
        content: [{
          title: '可自行编写6位数编码',
          content: []
        }]
      },
      'PackageWeight': {
        name: 'Package Weight（包裹重量）',
        content: [{
          title: '填写物品总重量（含包装重量）',
          content: []
        }]
      },
      'CustomDeclareValue': {
        name: 'Custom Declare Value（自定义价值声明）',
        content: [{
            title: '跨境电商包裹直接邮寄（快递）时，通常在物流面单上填写物品的价值，因每个国家“行邮税”免征额度不同，尽量填写价值在行邮税免征范围内。',
            content: []
          },
          {
            title: '如价值特高物品，尽量填写真实价值。为因运输过程中物品破损或丢失，索赔时的价值判定。',
            content: []
          }
        ]
      },

    }
  },
  mutations: {
    setData(state, {
      dataKey,
      setKey,
      value
    }) {
      if (dataKey) {
        state[dataKey] = value
      } else {
        setObj(state, setKey, value)
      }
    },
    initData() {

    }
  },
  actions: {
    remoteUpdataLocal({
      commit
    }, {
      url,
      param,
      setKey,
      fn
    }) {
      window.axios.post(url, param).then(res => {
        if (res.succeed) {
          commit('setData', {
            setKey: setKey,
            value: fn(res)
          })
        }
      })
    },
    getProductList({
      commit
    }, params) {
      return new Promise(resolve => {
        window.axios.post('/student/buyer/product/list', params || {}).then(res => {
          commit('setData', {
            setKey: ['product', 'list'],
            value: res.items
          });
          resolve(res)
        })
      })
    },
    getOrderList({
      commit
    }) {
      window.axios.post('/student/product/list', {}).then(res => {
        commit('setData', {
          setKey: ['product', 'list'],
          value: res.items
        });
        commit('setData', {
          setKey: ['product', 'pagination'],
          value: res.pagination
        })
      })
    },
    getBuyerList({
      commit
    }) {
      window.axios.post('/student/order/buyer/list', {}).then(res => {
        commit('setData', {
          setKey: ['buyerOrders', 'list'],
          value: res.items
        });
        commit('setData', {
          setKey: ['buyerOrders', 'pagination'],
          value: res.pagination
        })
      })
    },
    getCart({
      commit
    }) {
      window.axios.post('/student/buyer/order/cart/list').then(res => {
        commit('setData', {
          dataKey: 'cart',
          value: res.items
        })
      })
    },
    getAddress({
      commit
    }) {
      window.axios.post('/student/user/buyer/address/list').then(res => {
        commit('setData', {
          dataKey: 'address',
          value: res
        })
      })
    },
    updateDefaultAddress({
      state,
      dispatch
    }, data) {
      let $address = {}
      for (let i = 0; i < state.address.items.length; i++) {
        if (data.id === state.address.items[i].id) {
          $address = state.address.items[i]
        }
      }
      $address.hasDefault = true;
      window.axios.post('/student/user/buyer/address/modify', $address).then(res => {
        if (res.succeed) {
          dispatch('getAddress')
        }
      })

    }
  },
  modules: {},
  plugins: [createPersistedState()],
})